module.exports = __webpack_public_path__ + "static/img/pic_zrdaoshi_bm@2x.24b840f6.png";